import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import amyPortrait from "@/assets/amy.jpg";

const EDUCATION = [
  "Bachelor of Science, Biology — University at Buffalo, Honors College, Summa Cum Laude",
  "Doctor of Dental Surgery — University at Buffalo, School of Dental Medicine",
  "Certificate in Orthodontics — University of Detroit Mercy",
  "Master of Science, Orthodontics and the Temporo-mandibular Joint (TMJ) — University of Detroit Mercy",
];

export default function DrAmy() {
  return (
    <>
      <PageHero
        eyebrow="Meet your orthodontist"
        title="Amy Harel, DDS"
        intro="Personalized, modern orthodontic care — delivered by someone who genuinely loves the craft."
      />

      <section className="bg-cream-50">
        <div className="section grid gap-14 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="relative mx-auto aspect-[4/5] max-w-sm overflow-hidden rounded-[2rem] border border-cream-300/60 bg-sage-100 shadow-soft">
              <img
                src={amyPortrait}
                alt="Portrait of Dr. Amy Harel"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="mt-8 rounded-2xl border border-blush-100 bg-blush-50/60 p-6">
              <h3 className="font-serif text-lg text-sage-800">
                Outside the office
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-sage-700/90">
                Dr. Amy enjoys spending time with her husband Gil, and their
                four children, Aria, Liora, Ronen and Zev. They are a musical
                family who love listening to everything from country and
                classical to Broadway and Disney tunes — don't be surprised if
                you hear her singing along to the office radio!
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-2">
            <p className="eyebrow">Biography</p>
            <h2 className="mt-4 text-3xl sm:text-4xl">
              An Orthodontist, A Mom, and Your Family's Smile Expert
            </h2>

            <div className="mt-6 space-y-5 text-sage-700/90">
              <p>
                Dr. Amy Harel grew up in New York City and attended the
                University at Buffalo Honors College. She graduated{" "}
                <em>summa cum laude</em> with a bachelor's degree in Biology,
                then continued her studies at the University at Buffalo School
                of Dental Medicine, where she completed her Doctor of Dental
                Surgery and finished in the top 5% of her class.
              </p>
              <p>
                Wanting to focus her career exclusively on orthodontics, she
                immediately entered the Postgraduate Orthodontic Residency at
                the University of Detroit Mercy. There she earned a Certificate
                in Orthodontics as well as a Master of Science exploring the
                effect of orthodontic appliances on temporo-mandibular joint
                (TMJ) remodeling.
              </p>
              <p>
                Dr. Amy strongly believes in the importance of keeping up with
                the latest developments in orthodontics. She frequently attends
                continuing education courses to stay on the cutting edge of the
                technology and techniques the profession has to offer. She
                particularly enjoys treatment planning on digital platforms,
                using 3-dimensional simulations and 3-d printed appliances.
              </p>
            </div>

            <div className="mt-10 rounded-2xl border border-sage-100 bg-cream-100/60 p-6 sm:p-8">
              <h3 className="font-serif text-xl text-sage-800 sm:text-2xl">
                Dr. Amy's Treatment Philosophy
              </h3>
              <div className="mt-4 space-y-4 text-sage-700/90">
                <p>
                  Dr. Amy's treatment philosophy is simple: she treats every
                  patient the way she would want herself and her own children
                  to be treated. As a mother of four, she understands firsthand
                  that every child is unique, with their own personality,
                  needs, strengths, and challenges. No two children are alike,
                  and she believes orthodontic care should reflect that
                  individuality.
                </p>
                <p>
                  Rather than taking a one-size-fits-all approach, Dr. Amy
                  carefully tailors each treatment plan to the person sitting in
                  her chair. She takes the time to understand her patients'
                  lifestyles, schedules, goals, and preferences, ensuring that
                  treatment is not only effective but also fits comfortably
                  into their daily lives. Whether recommending braces, clear
                  aligners, or other treatment options, she thoughtfully
                  considers which approach will best support each patient's
                  needs and help them achieve a healthy, confident smile.
                </p>
                <p>
                  Above all, Dr. Amy is committed to providing the same level
                  of care, attention, and compassion that she would want for
                  her own family.
                </p>
              </div>
            </div>

            <div className="mt-10">
              <div className="rounded-2xl border border-sage-100 bg-cream-100/60 p-6">
                <h3 className="font-serif text-lg text-sage-800">Education</h3>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-sage-700/90">
                  {EDUCATION.map((item) => (
                    <li key={item} className="flex gap-2">
                      <span aria-hidden="true" className="text-blush-400">
                        •
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link to="/#contact" className="btn-primary">
                Request an appointment
              </Link>
              <Link to="/" className="btn-secondary">
                Back to home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
